/* PagingInstructionsFeed.js */

const PagingFeed = require("../../../../../../lib/PagingFeed");

class PagingInstructionsFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedInstructionsFeed({}, this._entityFields, this._sort, {
            skip: 0,
            limit: this._pageSize * 2,
        });
    }

    _feedReestablish() {
        return this._feed.reestablishFeed(this._activeOrgId, {}, this._entityFields, this._sort);
    }
}

module.exports = PagingInstructionsFeed;
